import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DataParser from "../../../../utlits/Dataparser";
import CompanyShiftService from "../../../../Services/CompanyShiftService";

import { Helmet } from "react-helmet";
import { paginate } from "../../../../utlits/Paginate.js";
import Pagination from "../../../Reuseable/Pagination";
import { Tooltip, message } from "antd";
import TableSkeleton from "../../../Reuseable/TableSkeleton";

const CompanyShifts = () => {
    const [shifts, setShifts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [deleteModal, setDeleteModal] = useState({ visible: false, shiftId: null });

    const fetchShifts = async () => {
        setLoading(true);
        try {
            const resp = await CompanyShiftService.getAll();
            if (resp.success) {
                setShifts(resp.data);
            }
        } catch (error) {
            console.log("Error fetching shifts", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchShifts();
    }, []);

    const handelPageChange = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
    };

    useEffect(() => {
        if (pageSize > 15) {
            setCurrentPage(1);
        }
    }, [pageSize]);

    const deleteShift = (id) => {
        setDeleteModal({ visible: true, shiftId: id });
    };

    const confirmDelete = async () => {
        try {
            const resp = await CompanyShiftService.delete(deleteModal.shiftId);
            if (resp.success) {
                message.success("Shift deleted successfully");
                setDeleteModal({ visible: false, shiftId: null });
                fetchShifts();
            }
        } catch (error) {
            message.error("Error deleting shift");
            console.log(error);
        }
    };

    const duplicateShift = async (id) => {
        try {
            const resp = await CompanyShiftService.duplicate(id);
            if (resp.success) {
                message.success("Shift duplicated successfully");
                fetchShifts();
            } else {
                message.error(resp.message || "Error duplicating shift");
            }
        } catch (error) {
            message.error("Error duplicating shift");
            console.log(error);
        }
    };

    const PaginatedData = paginate(shifts, currentPage, pageSize);

    return (
        <>
            <Helmet>
                <title>Company Shifts - Planit</title>
            </Helmet>

            {deleteModal.visible && (
                <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }} onClick={() => setDeleteModal({ visible: false, shiftId: null })}>
                    <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                        <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                            <div className="modal-header border-0 pb-1">
                                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Shift</h5>
                                <button type="button" className="btn-close" onClick={() => setDeleteModal({ visible: false, shiftId: null })} />
                            </div>
                            <div className="modal-body pt-2 pb-2">
                                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this shift?</p>
                                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                                    <i className="uil uil-exclamation-triangle me-1" />
                                    This action cannot be undone.
                                </p>
                            </div>
                            <div className="modal-footer border-0 pt-1">
                                <button
                                    type="button"
                                    className="btn btn-danger waves-effect waves-light"
                                    style={{ borderRadius: "5px", fontSize: "13px" }}
                                    onClick={confirmDelete}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="main-content">
                <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 px-0">
                                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                                    <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                                        <ol className="breadcrumb mb-0">
                                            <li className="breadcrumb-item">
                                                <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                                            </li>
                                            <li className="breadcrumb-item active">Company Shifts</li>
                                        </ol>
                                        <Link to={`/${DataParser.CompanyIdentifierRole()}/company_shifts/create`}>
                                            <button type="button" className="btn btn-primary waves-effect waves-light" style={{ borderRadius: "5px" }}>
                                                Add Shift
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12 px-0">
                                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                                    <div className="card-body p-0">
                                        <div className="table-responsive listing-table-wrapper">
                                            <table className="table mb-0 custom-table listing-table">
                                                <thead>
                                                    <tr className="tableHeaderbg">
                                                        <th>Sr#</th>
                                                        <th>Shift Name</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loading ? (
                                                        <TableSkeleton cols={3} rows={6} />
                                                    ) : (
                                                        <>
                                                            {PaginatedData && PaginatedData.length > 0 ? (
                                                                PaginatedData.map((shift, index) => (
                                                                    <tr key={shift.id}>
                                                                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                                                                        <td>{shift.name}</td>
                                                                        <td className="tableset">
                                                                            <Link
                                                                                to={`/${DataParser.CompanyIdentifierRole()}/company_shifts/edit/${shift.id}`}
                                                                                className="cursor-pointer iconscolor"
                                                                            >
                                                                                <Tooltip title="Edit Shift">
                                                                                    <i className="uil-pen iconscolor" />
                                                                                </Tooltip>
                                                                            </Link>
                                                                            <Link
                                                                                to="#"
                                                                                onClick={(e) => { e.preventDefault(); deleteShift(shift.id); }}
                                                                                className="cursor-pointer iconscolor"
                                                                            >
                                                                                <Tooltip title="Delete Shift">
                                                                                    <i className="uil-trash iconscolor" />
                                                                                </Tooltip>
                                                                            </Link>
                                                                            <Link
                                                                                to="#"
                                                                                onClick={(e) => { e.preventDefault(); duplicateShift(shift.id); }}
                                                                                className="cursor-pointer iconscolor"
                                                                            >
                                                                                <Tooltip title="Duplicate Shift">
                                                                                    <i className="uil-copy iconscolor" />
                                                                                </Tooltip>
                                                                            </Link>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center">
                                                                        No company shifts found. Click 'Add Shift' to create one.
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </>
                                                    )}
                                                </tbody>
                                            </table>

                                            {shifts.length > pageSize && (
                                                <div className="d-flex justify-content-center mt-4">
                                                    <Pagination
                                                        itemCount={shifts.length}
                                                        currentPage={currentPage}
                                                        pageSize={pageSize}
                                                        onPageChange={handelPageChange}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompanyShifts;
